// actions.js
import {
  FETCH_AGENCIES_REQUEST,
  FETCH_AGENCIES_SUCCESS,
  FETCH_AGENCIES_FAILURE,
  DELETE_AGENCIES_REQUEST,
  DELETE_AGENCIES_FAILURE,
  DELETE_AGENCIES_SUCCESS,
  FETCH_AGENCY_REQUEST,
  FETCH_AGENCY_SUCCESS,
  FETCH_AGENCY_FAILURE,
  UPDATE_AGENCIES_REQUEST,
  UPDATE_AGENCIES_SUCCESS,
  UPDATE_AGENCIES_FAILURE,
  FETCH_AGENCIES_RELEASE_REQUEST,
  FETCH_AGENCIES_RELEASE_SUCCESS,
  FETCH_AGENCIES_RELEASE_FAILURE,
  OPEN_EDIT_PAGE_AGENCY,
  OPEN_EDIT_PAGE_AGENCY_SUCCESS,
  CLEAR_AGENCY_ERRORS,
  CLEAR_AGENCY_SUCCESS,
} from './actionTypes';

export const fetchAgenciesRequest = () => ({
  type: FETCH_AGENCIES_REQUEST,
});

export const fetchAgenciesSuccess = (agencies) => ({
  type: FETCH_AGENCIES_SUCCESS,
  payload: agencies,
});

export const fetchAgenciesFailure = (error) => ({
  type: FETCH_AGENCIES_FAILURE,
  payload: error,
});

export const fetchAgenciesReleaseRequest = () => ({
  type: FETCH_AGENCIES_RELEASE_REQUEST,
});

export const fetchAgenciesReleaseSuccess = (agenciesRelease) => ({
  type: FETCH_AGENCIES_RELEASE_SUCCESS,
  payload: agenciesRelease,
});

export const fetchAgenciesReleaseFailure = (error) => ({
  type: FETCH_AGENCIES_RELEASE_FAILURE,
  payload: error,
});

export const fetchAgencyRequest = (id) => ({
  type: FETCH_AGENCY_REQUEST,
  payload: id
});

export const fetchAgencySuccess = (agency) => ({
  type: FETCH_AGENCY_SUCCESS,
  payload: agency,
});

export const fetchAgencyFailure = (error) => ({
  type: FETCH_AGENCY_FAILURE,
  payload: error,
});

export const updateAgencyRequest = (agency, navigate) => ({
  type: UPDATE_AGENCIES_REQUEST,
  payload: { agency, navigate }
});

export const updateAgencySuccess = () => ({
  type: UPDATE_AGENCIES_SUCCESS,
});

export const updateAgencyFailure = (error) => ({
  type: UPDATE_AGENCIES_FAILURE,
  payload: error,
});

export const openEditPageAgency = (id, navigate) => ({
  type: OPEN_EDIT_PAGE_AGENCY,
  payload: { id, navigate }
});

export const openEditPageAgencySuccess = () => ({
  type: OPEN_EDIT_PAGE_AGENCY_SUCCESS,
});

export const deleteAgencyRequest = (id) => ({
  type: DELETE_AGENCIES_REQUEST,
  payload: id
});

export const deleteAgencySuccess = (id) => ({
  type: DELETE_AGENCIES_SUCCESS,
  payload: id,
});

export const deleteAgencyFailure = (error) => ({
  type: DELETE_AGENCIES_FAILURE,
  payload: error,
});

export const clearAgencyErrors = () => ({
  type: CLEAR_AGENCY_ERRORS,
});

export const clearAgencySuccess = () => ({
  type: CLEAR_AGENCY_SUCCESS,
});